import { SafeUrl } from "@angular/platform-browser"
import { Team } from "./team.model"

export class Season {
    _id: string = ''
    season: string = ''
    competition: string = ''
    qualy?: QualyTeam[] = []
    imgUrl: SafeUrl = ''
}

export class QualyTeam {
    team: Team = new Team()
    points: number = 0
    goals: number = 0
    goals_against: number = 0
    wins?: number = 0
    draws?: number = 0
    looses?: number = 0
}